import {useState} from 'react';
import {ArrowDownTrayIcon} from '@heroicons/react/24/outline';
import {toast} from 'react-toastify';
import {useIntl} from 'react-intl';
import {Calendar} from 'react-date-range';
import {format as formatDate} from 'date-fns';

import {ReportsHTTP} from '../../../providers/reports';

import Button from '../../../../../components/Button';
import PageHeader from '../../../../../components/_layouts/PageHeader';
import SectionWrapper from '../../../../../components/SectionWrapper';

const DailyAttendance = () => {
  const {formatMessage} = useIntl();

  const [loading, setLoading] = useState(false);
  const [selectedDate, setDate] = useState(new Date());

  const createdPDF = async () => {
    try {
      if (!selectedDate) return;

      setLoading(true);
      const date = formatDate(selectedDate, 'MM-dd-yyyy');
      await ReportsHTTP.downloadDailyAttendancePDF(date);
    } catch (error) {
      toast.error(formatMessage({id: 'toast.something-wrong'}));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHeader
        title={formatMessage({id: 'menu.reports.daily-attendance'})}
        breadcrumbs={[
          {
            id: 'reports',
            label: formatMessage({id: 'reports'}),
          },
          {
            id: 'timecard-pdf',
            label: formatMessage({id: 'menu.reports.daily-attendance'}),
          },
        ]}
      />

      <SectionWrapper
        toolbarTitle={formatMessage({id: 'select-date'})}
        toolbar={
          <>
            <div style={{width: 350}}>
              <Calendar
                maxDate={new Date()}
                onChange={(item) => setDate(item)}
                date={selectedDate}
                showMonthAndYearPickers={false}
              />
            </div>

            <Button
              extraClassName="shadow-sm ml-5"
              disabled={loading || !selectedDate}
              onClick={() => createdPDF()}>
              <>
                <ArrowDownTrayIcon
                  className="-ml-1 mr-2 h-5 w-5"
                  aria-hidden="true"
                />
                {loading
                  ? formatMessage({id: 'creating-pdf'})
                  : formatMessage({id: 'download-pdf'})}
              </>
            </Button>
          </>
        }>
        <div style={{height: 330}} />
      </SectionWrapper>
    </>
  );
};

export default DailyAttendance;
